



















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { CameraConfig } from '@/store/cameras/types'
import { noop } from 'vue-class-component/lib/util'
import { SocketActions } from '@/api/socketActions'

/**
 * Adaptive load credit to https://github.com/Rejdukien
 */
@Component({})
export default class CameraItem extends Vue {
  @Prop({
    type: Object,
    required: true
  })
  camera!: CameraConfig

  // Adaptive load counters
  request_start_time = performance.now()
  start_time = performance.now()
  time = 0
  request_time = 0
  time_smoothing = 0.6
  request_time_smoothing = 0.1
  currentFPS = '0'

  // URL used by camera
  cameraUrl = ''
  cameraFullScreenUrl = ''

  // iframe height
  cameraHeight = 720

  // Maintains the last cachebust string
  refresh = new Date().getTime()

  // Callback to cancel requestAnimationFrame() when component is being destroyed.
  cancelCameraTransform = noop

  /* config:any = {
    iceServers: [
      { urls: 'stun:39.100.101.108:5349', username: 'test', credential: 'owejoij823wjueo', credentialType: 'password' }
    ]
  } */
  // eslint-disable-next-line no-undef
  config: RTCConfiguration = {
    iceServers: [
      {
        urls: ['turn:39.100.101.108:3478'],
        username: 'test',
        credential: 'owejoij823wjueo'
      }
    ]
    // iceTransportPolicy: 'all',
    // iceCandidatePoolSize: 0
  }

  play = false

  /**
   * Handle any transforms the user may have set on the camera image.
   */
  cameraTransformStyle (element: HTMLElement) {
    const config = this.camera
    let transforms = ''

    if (!config.rotate) {
      transforms += config && config.flipX ? ' scaleX(-1)' : ''
      transforms += config && config.flipY ? ' scaleY(-1)' : ''
    } else {
      let scaling = 1
      if (config.rotate !== '180') {
        scaling = element.clientHeight / element.clientWidth
        if (scaling > 1) {
          scaling = element.clientWidth / element.clientHeight
        }
      }

      transforms += config && config.flipX ? ` scaleX(-${scaling})` : ` scaleX(${scaling})`
      transforms += config && config.flipY ? ` scaleY(-${scaling})` : ` scaleY(${scaling})`
      transforms += ` rotate(${config.rotate}deg)`
    }

    return transforms.trimLeft().length
      ? { transform: transforms.trimLeft() }
      : {}
  }

  @Watch('camera', { immediate: true })
  onCameraChange () {
    this.setUrl()
  }

  /**
   * On creation, set the initial urls and bind the visibility listener.
   */
  created () {
    document.addEventListener('visibilitychange', this.setUrl, false)
    this.cancelCameraTransform = this.createTransformAnimation()
  }

  /**
   * make sure to clear the URL and remove the listener when we destroy the
   * component.
   */
  beforeDestroy () {
    this.cancelCameraTransform()
    this.cameraUrl = ''
    this.cameraFullScreenUrl = ''
    document.removeEventListener('visibilitychange', this.setUrl)
  }

  /**
   * For image based streams / adaptive loads, set the refresh token
   * and set the new cachebusted url.
   */
  handleRefresh () {
    if (!document.hidden) {
      this.refresh = new Date().getTime()
      // this.setUrl()
      this.currentFPS = Math.round(1000 / this.time).toLocaleString(undefined, { minimumIntegerDigits: 2 })
      this.$nextTick(() => {
        const hostUrl = new URL(document.URL)
        const url = new URL(this.cameraUrl, hostUrl.origin)
        url.searchParams.set('cacheBust', this.refresh.toString())
        this.request_start_time = performance.now()
        this.cameraUrl = url.toString()
      })
    } else {
      this.cameraUrl = ''
    }
  }

  /**
   * Handles the reload of the image, forces a new cachebust and sets the
   * performance counters for the next load.
   * It only used for the adaptive load type.
   */
  handleImgLoad () {
    if (
      this.camera &&
      this.camera.type === 'mjpgadaptive'
    ) {
      const fpsTarget = (!document.hasFocus() && this.camera.fpsidletarget) || this.camera.fpstarget || 10
      const end_time = performance.now()
      const current_time = end_time - this.start_time
      this.time = (this.time * this.time_smoothing) + (current_time * (1.0 - this.time_smoothing))
      this.start_time = end_time

      const target_time = 1000 / fpsTarget

      const current_request_time = performance.now() - this.request_start_time
      this.request_time = (this.request_time * this.request_time_smoothing) + (current_request_time * (1.0 - this.request_time_smoothing))
      const timeout = Math.max(0, target_time - this.request_time)

      this.$nextTick(() => {
        setTimeout(this.handleRefresh, timeout)
      })
    }
  }

  initWebRTC () {
    this.play = true
    const peerConnection = new RTCPeerConnection(this.config)
    this.$store.commit('cameras/setPeerConnection', {
      id: this.camera.id,
      connection: peerConnection
    })

    peerConnection.addEventListener('track', event => {
      console.log('获取track', event)
      const camera = document.getElementById('camera_webrtc') as HTMLVideoElement
      camera.srcObject = event.streams[0]
      this.play = true
    })
    peerConnection.addTransceiver('video', { direction: 'recvonly' })

    // peerConnection.addEventListener('iceconnectionstatechange', this.handleConnectionChange)
    const camera_id = this.camera.id
    peerConnection.createOffer().then(description => {
      console.log('设置setLocalDescription', description)
      return peerConnection.setLocalDescription(description)
    }).then(() => {
      console.log('注册事件icegatheringstatechange')
      return new Promise(function (resolve) {
        console.log('注册事件 step1')
        if (peerConnection.iceGatheringState === 'complete') {
          console.log('注册事件 step2')
          resolve([])
        } else {
          console.log('注册事件 step3')
          function checkState () {
            if (peerConnection.iceGatheringState === 'complete') {
              console.log('注册事件 step4')
              peerConnection.removeEventListener('icegatheringstatechange', checkState)
              resolve([])
            }
          }
          peerConnection.addEventListener('icegatheringstatechange', checkState)
        }
      })
    }).then(() => {
      const offer = peerConnection.localDescription
      console.log('发送offer', offer)
      SocketActions.serverWebRTC(camera_id, offer)
    }).catch(function (e) {
      alert(e)
    })
  }

  /**
   * Sets the correct (cachebusted if applicable) camera url.
   */
  setUrl () {
    if (!document.hidden) {
      const type = this.camera.type
      const baseUrl = this.camera.url
      const hostUrl = new URL(document.URL)
      const url = new URL(baseUrl, hostUrl.origin)

      this.cameraHeight = this.camera.height || 720

      if (type === 'mjpgstream') {
        url.searchParams.append('cacheBust', this.refresh.toString())
        if (!url.searchParams.get('action')?.startsWith('stream')) {
          url.searchParams.set('action', 'stream')
        }
        this.cameraUrl = url.toString()
        this.cameraFullScreenUrl = this.cameraUrl
      }

      if (type === 'mjpgadaptive') {
        this.request_start_time = performance.now()
        url.searchParams.append('cacheBust', this.refresh.toString())
        if (!url.searchParams.get('action')?.startsWith('snapshot')) {
          url.searchParams.set('action', 'snapshot')
        }
        this.cameraUrl = url.toString()
        url.searchParams.set('action', 'stream')
        this.cameraFullScreenUrl = url.toString()
      }

      if (type === 'ipstream' || type === 'iframe') {
        this.cameraUrl = baseUrl
        this.cameraFullScreenUrl = baseUrl
      }

      // if (type === 'webrtc') {
      //   this.initWebRTC()
      // }
      // if (type === 'webrtc' && (this.camera.remoteDescription !== undefined)) {
      //   this.setWebRTC()
      // }
    } else {
      this.cameraUrl = ''
      this.cameraFullScreenUrl = ''
    }
  }

  /**
   * Calls `requestAnimationFrame` indefinitely to apply camera transformations.
   * The call to `requestAnimationFrame` is required because of the dependency
   * on loaded node sizes in the document.
   */
  createTransformAnimation () {
    let animating = true

    const animate = () => {
      requestAnimationFrame(() => {
        if (!animating) {
          return
        }

        const image = this.$refs.camera_image as HTMLElement | undefined

        if (image) {
          // Call to Object.assign() might not be suitable here.
          Object.assign(image.style, this.cameraTransformStyle(image))
        }

        animate()
      })
    }

    animate()

    return () => {
      animating = false
    }
  }
}
